// extracted by mini-css-extract-plugin
export default {"wrapper":"Alert_wrapper__RtpmE","small":"Alert_small__Erg7i","error":"Alert_error__Lwqqg","warning":"Alert_warning__X7Cnp","success":"Alert_success__-qsGm"};